import React, { useEffect, useState } from "react";
import { Button, ColorPicker, Divider, Modal } from "antd";
import { useSelector } from "react-redux";
import { useActionDialogSpeakerColor } from "hook/draft/dialog/useActionDialogAdvance";
import { draftDialogSpeakerColor } from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogChangeColor = () => {
  // -------------------------- VAR -----------------------------
  const { handleCancel, handleSave } = useActionDialogSpeakerColor();
  // -------------------------- STATE ---------------------------
  const [color, setColor] = useState("white");
  const [bgColor, setBgColor] = useState("black");

  // -------------------------- REDUX ---------------------------
  const data = useSelector(draftDialogSpeakerColor);
  const open = !!data;
  const origin = data?.origin;
  const id = data?.id;
  const selected = origin?.find((o) => o.id === id) || null;

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (!selected) return;
    setColor(selected?.color);
    setBgColor(selected?.bgColor);
  }, [selected]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="flex flex-col gap-3">
        <Divider className="my-4 border-dashed" />
        {renderBgColor()}
        {renderTxtColor()}
        <Divider className="my-4 border-dashed" />
        {renderFooter()}
      </div>
    );
  };

  const renderBgColor = () => {
    return (
      <div className="flex flex-row items-center gap-1">
        <span>Background Color:</span>
        <ColorPicker
          value={bgColor}
          onChangeComplete={(color) => setBgColor(color.toHexString())}
          showText
        />
      </div>
    );
  };

  const renderTxtColor = () => {
    return (
      <div className="flex flex-row items-center gap-1">
        <span>Text Color:</span>
        <ColorPicker
          value={color}
          onChangeComplete={(color) => setColor(color.toHexString())}
          showText
        />
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div className="flex flex-row items-center justify-end gap-2">
        <Button onClick={handleCancel}>Huỷ</Button>
        <Button onClick={() => handleSave({ bgColor, color })} type="primary">
          Lưu
        </Button>
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={handleCancel}
      title="Đổi màu Speaker"
      centered
      footer={null}
      open={open}
    >
      {renderBody()}
    </Modal>
  );
};
export default DialogChangeColor;
